import { FC, useEffect, useState } from 'react';

import { SensitiveValueTextWrapper } from '@/shared/components';
import { useCurrencyRates } from '@/shared/hooks/currencies/useCurrencyRates';
import { CurrencyDisplayVariant, numbers } from '@/shared/utils/numbers';

type AssetValueFieldProps = {
  currency: string;
  amount: number;
  variant?: CurrencyDisplayVariant;
  hideCurrency?: boolean;
};

export const AssetValueField: FC<AssetValueFieldProps> = ({
  currency,
  amount,
  variant,
  hideCurrency,
}) => {
  const { calculateInBaseCurrency } = useCurrencyRates();
  const [value, setValue] = useState('');

  const fetchRate = async () => {
    const result = await calculateInBaseCurrency(currency, amount);

    const formatted = numbers.formatPrice(
      result.amount,
      hideCurrency ? null : result.currency,
      variant,
    );
    setValue(formatted);
  };

  useEffect(() => {
    fetchRate();
  }, []);

  return <SensitiveValueTextWrapper>{value}</SensitiveValueTextWrapper>;
};
